export default "__VITE_ASSET__304b78fe__"